






import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import { McWysiwyg } from '@mycure/vue-wysiwyg';
import {equals} from "../../utils";

@Component({
  components: { McWysiwyg },
})
export default class Editor extends Vue {
  // Value passed by v-model
  @Prop() public readonly value: any
  @Prop() public readonly label: any

  // Holder for muted value
  public mutable: any = this.value


  // If the v-model is updated in the parent
  @Watch('value')
  public valueChanged(newValue: any, oldValue: any) {
    if (!equals(newValue, oldValue)) {
      // if(newValue.latitude && newValue.longitude) {}
      this.mutable = newValue

    }
  }

  @Watch('mutable')
  public mutableChanged() {
    // Send v-model value to parent
    this.$emit('input', this.mutable)
  }

   }
